export default {
	action: "Transferir propriedade",
	confirmTitle: "Transferir propriedade",
	confirmMessage:
		"{name} vai receber um pedido para se tornar Proprietário; se aceitar, você passa a Administrador.",
	confirm: "Enviar pedido",
	requested: "Pedido enviado; aguardando a resposta de {name}.",
	pendingSent: "Transferência para {name} aguardando resposta até {date}.",
	cancel: "Cancelar pedido",
	canceled: "Pedido cancelado.",
	pageTitle: "Transferência de propriedade",
	pendingReceived: "{name} quer transferir para você a propriedade de {temple}.",
	explanation:
		"Ao aceitar, você passa a ser o Proprietário, e {name} continua como Administrador.",
	expiresAt: "O pedido vale até {date}.",
	accept: "Aceitar",
	decline: "Recusar",
	acceptedRelogin: "Transferência concluída: saia e entre de novo para usar o acesso de Proprietário.",
	accepted: "Agora você é o Proprietário do terreiro.",
	declined: "Pedido recusado.",
	none: "Nenhum pedido de transferência pendente.",
	banner: "Você recebeu um pedido de transferência da propriedade do terreiro.",
	viewRequest: "Ver pedido",
	error: "Não foi possível concluir; tente novamente.",
};
